import React from 'react'

const Formularios = () => {
  return (
    <div className='container fondotransparente p-5 my-5 '>
      <center><h1 className=" p-5 botonbordeazul text-white px-5 mx-5 py-3">Formulario de Autoexclusión</h1></center>
      <br />
      <br />

      <div className="accordion" id="accordionPanelsStayOpenExample">
        <div className="accordion-item">
          <h2 className="accordion-header" id="panelsStayOpen-headingOne">
            <button className="h3 accordion-button text-light bg-primary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
              ¿QUE ES EL ACTA DE ACUERDO DE AUTOEXCLUSIÓN?
            </button>
          </h2>
          <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingOne">
            <div className="accordion-body">
              <p>Es una herramienta voluntaria y disponible para los jugadores que consideren que tienen un problema con su modo de jugar, mediante el cual el jugador solicita la no admisión o ingreso al casino o salas de juego en la provincia de Jujuy. Consiste un acuerdo entre la persona que lo solicita con los operadores de juego. Deberá estar firmada por la persona interesada, y tendrá un periodo de tiempo determinado. El periodo mínimo será de dos años (2). Este último se renovara automáticamente de no constar un acta de levantamiento  o revocación que solo se podrá solicitar pasado el periodo mínimo. Ese periodo mínimo está fundamentado en la posibilidad que la persona con problemas de juego patológico pueda acceder a espacios y tratamientos de salud mental. Para solicitar le revocación, presentarse en forma presencial en el inprojuy con certificado de tratamiento por personal idóneo.</p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
            <button className="h3 accordion-button text-light bg-primary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
              ¿PARA QUIEN ES?
            </button>
          </h2>
          <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
            <div className="accordion-body">
              <p>PARA Toda aquella persona que esté interesada en no ingresar a las salas de juego  y  casinos de la Provincia de Jujuy.</p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="panelsStayOpen-headingThree">
            <button className="h3 accordion-button text-light bg-primary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
              ¿QUIEN LO PUEDE REALIZAR?
            </button>
          </h2>
          <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
            <div className="accordion-body">
              <p>Cualquier persona que este interesada</p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="panelsStayOpen-headingFour">
            <button className="h3 accordion-button text-light bg-primary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="false" aria-controls="panelsStayOpen-collapseFour">
              ¿QUE NECESITO PARA HACER EL TRAMITE?
            </button>
          </h2>
          <div id="panelsStayOpen-collapseFour" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFour">
            <div className="accordion-body">
              <p>El acta de autoexclusión  el usuario de juegos de azar podrá  descargarla DE AQUI, la podrá llenar y deberá  completarla  y firmarla,  y ser entregada en forma personal  en el inprojuy. JUNTO A COPIA DEL DNI Y DOS FOTOS, o en su defecto acepto me tomen una fotografía,  aceptando que las mismas sean remitidas a las Salas de Juego.</p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="panelsStayOpen-headingFive">
            <button className="h3 accordion-button text-light bg-primary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="false" aria-controls="panelsStayOpen-collapseFive">
              ¿CUANTO CUESTA?
            </button>
          </h2>
          <div id="panelsStayOpen-collapseFive" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFive">
            <div className="accordion-body">
              <p>Es voluntario y GRATUITO</p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="panelsStayOpen-headingSix">
            <button className="h3 accordion-button text-light bg-primary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSix" aria-expanded="false" aria-controls="panelsStayOpen-collapseSix">
              ¿SE PUEDE LEVANTAR LA AUTOEXCLUSIÓN?
            </button>
          </h2>
          <div id="panelsStayOpen-collapseSix" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingSix">
            <div className="accordion-body">
              <p>El periodo mínimo será de dos años (2). Este último se renovara automáticamente de no constar un acta de levantamiento  o revocación que solo se podrá solicitar pasado el periodo mínimo. Ese periodo mínimo está fundamentado en la posibilidad que la persona con problemas de juego patológico pueda acceder a espacios y tratamientos de salud mental. Para solicitar le revocación, presentarse en forma presencial en el inprojuy con certificado de tratamiento por personal idóneo.</p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="panelsStayOpen-headingSeven">
            <button className="h3 accordion-button text-light bg-primary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSeven" aria-expanded="false" aria-controls="panelsStayOpen-collapseSeven">
              ¿CUANTO DEMORO EN HACER EL TRAMITE DE REVOCACIÓN?
            </button>
          </h2>
          <div id="panelsStayOpen-collapseSeven" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingSeven">
            <div className="accordion-body">
              <p>Es una entrega del acta en el INPROJUY con una entrevista.</p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="panelsStayOpen-headingEight">
            <button className="h3 accordion-button text-light bg-primary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseEight" aria-expanded="false" aria-controls="panelsStayOpen-collapseEight">
              QUIEN SABRIA QUE LA PERSONA SE AUTOEXCLUYÓ?
            </button>
          </h2>
          <div id="panelsStayOpen-collapseEight" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingEight">
            <div className="accordion-body">
              <p>Es confidencial para las salas de juego de la provincia de jujuy, para el INPROJUY y para personal del ministerio de salud.</p>
            </div>
          </div>
        </div>

      </div>

      <br />
      <br />
      <p><strong>ACTA DE ACUERDO DE AUTOEXCLUSIÓN</strong></p>

      <br />

      <ul>
        <li className='h5 sinvineta'><a href=".\download\FormAutoexclusion.pdf" download >Descargar</a></li>
        <br />

        <hr className="wp-block-separator has-css-opacity" />
      </ul>
      <br />
      <p><strong>ACTA DE ACUERDO DE AUTOEXCLUSIÓN POR PARTE DE UN FAMILIAR</strong></p>
      <br />
      <ul>
        <li className='h5 sinvineta'><a href=".\download\FormAutoexFamiliar.pdf" download >Descargar</a></li>
      </ul>
      <br />
      <hr className="wp-block-separator has-css-opacity" />
      <br />
      <br />
      <br />
      <p><strong>ACTA DE LEVANTAMIENTO o REVOCACION DE LA AUTOEXCLUSIÓN VOLUNTARIA</strong></p>
      <br />
      <ul>
        <li className='h5 sinvineta'><a href=".\download\FormActaRevocacion.pdf" download >Descargar</a></li>
      </ul>
      <br />
      <hr className="wp-block-separator has-css-opacity" />
      <br />

      <h3>Preguntas frecuentes</h3>
      <div className="accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOne">
            <button className="h3 accordion-button text-light bg-primary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              Soy familiar de una persona con problemas con el juego, ¿Puedo llenar la ficha de autoexclusión por él?
            </button>
          </h2>
          <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              <p>No, la ficha de autoexclusión solo puede ser llenada por la persona que la solicita y en presencia del receptor de la misma.</p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingTwo">
            <button className="h3 accordion-button text-light bg-primary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              Soy un familiar (directo/indirecto) ¿Puedo autoexcluir a alguien contra su voluntad?
            </button>
          </h2>
          <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              <p> Sí, usted debe dirigirse a la fiscalía de turno o unidad judicial de su zona y denunciar que el jugador compulsivo está poniendo en riesgo patrimonio, lazos familiares, etc. y solicitar que se lo autoexcluya por vía judicial.</p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingThree">
            <button className="h3 accordion-button text-light bg-primary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              ¿Cuáles son los requisitos para presentar la autoexclusión?
            </button>
          </h2>
          <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              <p>Usted deberá presentarse en cualquier Sala de Juego de la Provincia de JUJUY  o en la casa central DEL INPROJUY. con DNI, dos fotos carnet, fotocopia DNI. Si usted todavía no cuenta con DNI renovado fotocopia primera, segunda hoja y cambio de domicilio si lo hubiere.</p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingFour">
            <button className="h3 accordion-button text-light bg-primary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
              Soy de otra Provincia, ¿Me puedo autoexcluir en JUJUY?
            </button>
          </h2>
          <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              <p>Le recordamos que la mayoría de las Provincias tiene este tipo de regímenes, por tanto debería consultar con la Lotería de su Provincia o institución  para poder realizar el trámite.
                Igualmente usted se puede autoexcluirse en Jujuy  sabiendo que el régimen de Autoexclusión tiene vigencia dentro del ejido provincial.</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Formularios